<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">
          Playground
        </h4>
      </div>
    </div>

    <div class="content-container flex-row">
      <section class="content large-padding large">
        <div class="grid-x grid-padding-x">
          <div class="cell-large-4">
            <span v-if="loading">
              Loading...
            </span>
            <span v-else-if="errors">
              Unable to connect to WS
            </span>
            <span v-else>
              <!-- <pre>Channels: {{channels}}</pre> -->
              Channel: {{ this.channelName }} <br>
              Totalt: {{ membersCount }}<br>

              Is owner: {{ isOwner }}

              <pre>
    Me:
    {{me}}

    Owner:
    {{owner}}

    All members:
    {{members}}
              </pre>
            </span>
          </div>
          <div class="cell large-2">&nbsp;</div>
          <div class="cell-large-4">
            <span v-if="loading2">
              Loading...
            </span>
            <span v-else-if="errors2">
              Unable to connect to WS
            </span>
            <span v-else>
              <!-- <pre>Channels: {{channels}}</pre> -->
              Channel: {{ this.secondChannel }} <br>
              Totalt: {{ membersCount2 }}<br>

              Is owner: {{ isOwner2 }}

              <pre>
    Me:
    {{me2}}

    Owner:
    {{owner2}}

    All members:
    {{members2}}
              </pre>
            </span>
          </div>
        </div>

      </section>
    </div>
  </div>
</template>

<script>
// import BilagService from '@/services/BilagService'
import Presence from '@/plugins/presence'

export default {
  name: 'Playground',
  components: {
  },
  data () {
    return {
      channelName: null,
      secondChannel: null
    }
  },
  computed: {
    channels: function () {
      return this.$store.getters['presence/channels']
    },

    channel: function () {
      return this.$store.getters['presence/channel'](this.channelName)
    },
    errors: function () {
      return this.$store.getters['presence/errors'](this.channelName)
    },
    loading: function () {
      return this.$store.getters['presence/loading'](this.channelName)
    },
    me: function () {
      return this.$store.getters['presence/me'](this.channelName)
    },
    members: function () {
      return this.$store.getters['presence/members'](this.channelName)
    },
    membersCount: function () {
      return this.$store.getters['presence/membersCount'](this.channelName)
    },

    owner: function () {
      return this.$store.getters['presence/owner'](this.channelName)
    },
    isOwner: function () {
      return this.$store.getters['presence/isOwner'](this.channelName)
    },

    errors2: function () {
      return this.$store.getters['presence/errors'](this.secondChannel)
    },
    loading2: function () {
      return this.$store.getters['presence/loading'](this.secondChannel)
    },
    channel2: function () {
      return this.$store.getters['presence/channel'](this.secondChannel)
    },
    me2: function () {
      return this.$store.getters['presence/me'](this.secondChannel)
    },
    members2: function () {
      return this.$store.getters['presence/members'](this.secondChannel)
    },
    membersCount2: function () {
      return this.$store.getters['presence/membersCount'](this.secondChannel)
    },

    owner2: function () {
      return this.$store.getters['presence/owner'](this.secondChannel)
    },
    isOwner2: function () {
      return this.$store.getters['presence/isOwner'](this.secondChannel)
    }
  },
  watch: {
    isOwner: function (newVal, oldVal) {
      console.log('Owner changed', newVal, oldVal)
      if (newVal && oldVal === false) {
        this.$helpers.showSuccessAlert('You are now the owner and can edit')
      }
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')

    console.log('Before destroy', this.channelName)
    this.presence.unsubscribe(this.channelName)
    this.presence.unsubscribe(this.secondChannel)
  },
  created () {
    this.presence = new Presence()

    window.jQuery('body').addClass('show-sidebar-xxlarge')

    console.log(Number('-12').toLocaleString('nb-NO'))
    console.log(Number('0.0').toLocaleString('nb-NO'))
    console.log(Number('-0').toLocaleString('nb-NO'))
    console.log(Number('-1').toLocaleString('nb-NO'))
    console.log(Number('-0.1').toLocaleString('nb-NO'))
    console.log(Number('-0.123').toLocaleString('nb-NO'))

    this.loading = false
    this.channelName = 'presence-objekt-123'
    this.secondChannel = 'presence-x-123'

    // this.$store.dispatch('presence/subscribe', 'presence-objekt-12345')
    console.log('Created: ', this.channelName)
    this.presence.subscribe(this.channelName)
    this.presence.subscribe(this.secondChannel)

    // this.loading = false

    // if (!this.userSettings.columns || this.userSettings.columns.length < 1) {
    //   this.userSettings.columns = []
    //   this.defaultColumns.forEach((item) => {
    //     this.userSettings.columns.push({ name: item.name, value: true })
    //   })
    // } else {
    //   this.userSettings.columns = this.userSettings.columns.reduce((unique, item) => {
    //     // First we skip those that doesnt exist in the defalts array
    //     let found = this.defaultColumns.findIndex(i => i.name === item.name)

    //     if (found === -1) {
    //       return unique
    //     }

    //     // And check so it isn't already added
    //     found = unique.findIndex(i => i.name === item.name)

    //     if (found !== -1) {
    //       return unique
    //     }

    //     return [...unique, { name: item.name, value: true }]
    //   }, [])

    //   // And lastly append the rest of the values
    //   this.defaultColumns.forEach((defaultItem) => {
    //     let found = this.userSettings.columns.findIndex(i => i.name === defaultItem.name)

    //     if (found === -1) {
    //       this.userSettings.columns.push({ name: defaultItem.name, value: false })
    //     }
    //   })
    // }

    // console.table(this.userSettings.columns)

    // Make a copy containing the current values
    // this.userSettings.columns.forEach((item) => {
    //   this.columnsOrder[item] = true
    // })

    // console.log(this.columnsOrder)
  },
  methods: {
    openBilagModal: function () {
      // const bilag = {
      //   Bilagsid: '1234dfg'
      // }

      // Test with bilag object
      // BilagService.getBilag('000009601c')
      //   .then(response => {
      //     this.openModal('bilag-email-pdf-modal',
      //       { query: response.data, internalWindow: true },
      //       'split'
      //     )
      //   })

      // Test with bilagsid
      const query = '00000a3a30'

      this.openModal('bilag-email-pdf-modal',
        { query: query, internalWindow: true },
        'split'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Playground.vue